module.exports = __webpack_public_path__ + "static/media/truck500.c4a3818d.svg";